import React from 'react';
import './FormComponent.css';
import logo from '../reshipes-logo.jpg';

const FormClosed = () => {
  return (
    <div className="page-wrapper">
      <div className="form-header">
        <img src={logo} alt="Reshipes Logo" className="form-logo" />
        <h1>Reshipes Bakery</h1>
      </div>
      <div className="form-section" style={{ textAlign: 'center', maxWidth: 500 }}>
        <h3>Orders Closed</h3>
        <p style={{ color: '#5a4030', fontSize: '1rem', margin: '16px 0 0' }}>
          We're not currently accepting orders. Check back soon!
        </p>
      </div>
    </div>
  );
};

export default FormClosed;
